
import { Vue, Component } from 'vue-property-decorator';

@Component({
  name: 'MainFooter',
})
export default class extends Vue {
  private goToCalendar() {
    this.$router.push({ name: 'Calendar' });
  }

  private goToLeague() {
    if (this.$route.name === 'League') {
      this.$root.$emit('league:reset-view');
    } else {
      this.$router.push({ name: 'League' });
    }
  }

  private goToHome() {
    this.$router.push({ name: 'Home' });
  }

  private goToGuest() {
    this.$router.push({ name: 'LeagueGuest' });
  }

  private goToMatch() {
    this.$router.push({ name: 'Match' });
  }

  private goToProfile() {
    this.$router.push({ name: 'MyPage' });
  }
}
